/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Deep_P2Inputs */

const en_to_typescript_deep_p2 = /** @type {(inputs: To_Typescript_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A null value produces the type null, not a nullable version of some other type. There is no way to tell from null alone whether the field is a nullable string or a nullable number, so the generator reports exactly what it saw. You almost always want to widen these by hand to string | null or whatever the field really is. The same reasoning applies to an empty array, which becomes any[] because its element type is unobservable.`)
};

const ko_to_typescript_deep_p2 = /** @type {(inputs: To_Typescript_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`null 값은 다른 타입의 nullable 버전이 아니라 null 타입을 만듭니다. null만 보고서는 그 필드가 nullable 문자열인지 nullable 숫자인지 알 방법이 없으므로, 생성기는 본 것을 그대로 보고합니다. 이런 필드는 거의 항상 손으로 string | null이나 실제 타입으로 넓혀야 합니다. 같은 논리가 빈 배열에도 적용되어 any[]가 됩니다. 요소 타입을 관찰할 수 없기 때문입니다.`)
};

const ja_to_typescript_deep_p2 = /** @type {(inputs: To_Typescript_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`null の値は、ほかの型の nullable 版ではなく null 型を作ります。null だけを見て、そのフィールドが nullable な文字列なのか数値なのか判断する方法はないので、ジェネレータは見たものをそのまま報告します。こうしたフィールドはほぼ必ず手で string | null や実際の型に広げる必要があります。同じ理屈が空の配列にも当てはまり、any[] になります。要素型が観測できないからです。`)
};

/**
* | output |
* | --- |
* | "A null value produces the type null, not a nullable version of some other type. There is no way to tell from null alone whether the field is a nullable strin..." |
*
* @param {To_Typescript_Deep_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_deep_p2 = /** @type {((inputs?: To_Typescript_Deep_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Deep_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_deep_p2(inputs)
	if (locale === "ko") return ko_to_typescript_deep_p2(inputs)
	return ja_to_typescript_deep_p2(inputs)
});